<div class="container">
  <div class="row no-gutters">
    <div class="col-12 ">
      
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblEditKeyDropLocation</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
            </a>
        </div>
      </div>
      <form *ngIf="keyDropLocation" name="form" #f="ngForm">
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="row">
                <div class="col-md-6 af-form-group">
                  <label for="dealer" translate>lblSelectDealer</label>
                  <div class="lbl-info">
                    <input disabled type="text" class="form-control" name="dealerName" #dealerName="ngModel"
                      [(ngModel)]="keyDropLocation.dealerName">
                  </div>
                </div>

                <div class="col-md-6 af-form-group">
                  <label for="name" translate>lblLocationName</label>
                  <div class="lbl-info">
                    <input disabled type="text" class="form-control" name="name" #name="ngModel" class="form-control"
                      [(ngModel)]="keyDropLocation.locationName" required>
                    <div *ngIf="name.invalid && (name.dirty || name.touched)" class="help-block text-danger">
                      <div *ngIf="name.errors.required"><span translate>lblNameRequired</span></div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6 af-form-group">
                  <label disabled for="name" translate>lblLocationType <strong class="mlt6 required"> * </strong></label>
                  <div class="lbl-info">
                    <div class="row">
                      <div class="col" *ngFor="let location of locationList">
                        <div class="lbl-info form-check mt-1">
                          <input class="form-check-input" [checked]="location.value==keyDropLocation.locationType"
                            type="radio" value={{location.value}} name="locationType" (click)="getValue(location.value)"
                            id="locationType">{{location.text}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="row">
            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
              <button type="submit" class="btn btn-primary btn-lg mr-sm-2" aria-label="Center Align" translate (click)="EditDetails()">
                <em class="far fa-save font16 align-top mr-2"></em>
                lblSaveChanges
              </button>
              <a class="btn btn-secondary btn-lg" (click)="OnClose()" translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
            </div>
          </div>
        </div>
        
      </form>
    </div>
  </div>
</div>